import { ConsorsUserInitController } from "./consorsUserInit.controller";
import template from "./consorsUserInit.html";

export const consorsUserInitComponent = {
	name: "consorsUserInitComponent",
	restrict: "E",
	template,
	controller: ConsorsUserInitController,
	controllerAs: "vm",
	bindings: {},
};



// WEBPACK FOOTER //
// ./src/app/components/consorsUserInit/consorsUserInit.component.js